import { createApp } from "vue";
import { createHead } from "@unhead/vue";
import { watch } from "vue";
import { createAppStore } from "./store";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { configure } from "vue-gtag";
configure({
  tagId: "AW-17455923513",
  config: {
    'campaign_id': "AW-17455923513"
  }
})
import Buefy from "buefy";
import "buefy/dist/buefy.min.css";
// Use a deterministic font across environments for VRT stability
// Noto Sans JP is bundled via @fontsource to avoid OS-dependent glyph metrics
import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/700.css";
// Bulma/Buefy カラーの最終上書き（ブランドの primary を固定）
import "./styles/overrides.css";
import App from "./App.vue";
import axios from "axios";
import axiosRetry from "axios-retry";
import VueLazyload from "vue3-lazyload";
import MarqueeText from "vue-marquee-text-component";
import VueMobileDetection from "vue-mobile-detection";
import { createAuth0 } from "@auth0/auth0-vue";
import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-3";
import adsUtils from "./utils/ads";
import copyUtils from "./utils/copy";
import toastUtils from "./utils/toast";
import loadingUtils from "./utils/loading";
import auth0Utils from "./utils/auth0";
import utilsUtils from "./utils/utils";
import modalUtils from "./utils/modal";
import downloadUtils from "./utils/download";
import emailUtils from "./utils/email";
import shareUtils from "./utils/share";
import groupUtils from "./utils/group";
import errorUtils from "./utils/error";
import router from "./router";
import { createRouterScroller } from "vue-router-better-scroller";
import { i18n } from "./i18n-setup";
import { registerSW } from "virtual:pwa-register";
registerSW({ immediate: true });

import { library } from "@fortawesome/fontawesome-svg-core";

// free solid
import { faStore } from "@fortawesome/free-solid-svg-icons/faStore";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons/faCreditCard";
import { faHeadset } from "@fortawesome/free-solid-svg-icons/faHeadset";
import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt";
import { faCogs } from "@fortawesome/free-solid-svg-icons/faCogs";
import { faCoins } from "@fortawesome/free-solid-svg-icons/faCoins";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons/faSyncAlt";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons/faCloudArrowDown";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons/faEyeSlash";
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons/faShieldAlt";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faHandHoldingUsd } from "@fortawesome/free-solid-svg-icons/faHandHoldingUsd";
import { faExclamation } from "@fortawesome/free-solid-svg-icons/faExclamation";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faTools } from "@fortawesome/free-solid-svg-icons/faTools";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons/faRedoAlt";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faListUl } from "@fortawesome/free-solid-svg-icons/faListUl";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons/faCloudArrowUp";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
import { faInfinity } from "@fortawesome/free-solid-svg-icons/faInfinity";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons/faUserGroup";
import { faCodeMerge } from "@fortawesome/free-solid-svg-icons/faCodeMerge";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faSkullCrossbones } from "@fortawesome/free-solid-svg-icons/faSkullCrossbones";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle"; // UploadComponent number-input
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { faUpLong } from "@fortawesome/free-solid-svg-icons/faUpLong";
import { faRocket } from "@fortawesome/free-solid-svg-icons/faRocket";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons/faRotateRight";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons/faShareNodes";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faShield } from "@fortawesome/free-solid-svg-icons/faShield";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons/faCalendarDays";
import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
import { faMicrochip } from "@fortawesome/free-solid-svg-icons/faMicrochip";
import { faLink } from "@fortawesome/free-solid-svg-icons/faLink";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faUnlock } from "@fortawesome/free-solid-svg-icons/faUnlock";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import { faImage } from "@fortawesome/free-solid-svg-icons/faImage";
import { faVideo } from "@fortawesome/free-solid-svg-icons/faVideo";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { faFileWord } from "@fortawesome/free-solid-svg-icons/faFileWord";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { faFilePowerpoint } from "@fortawesome/free-solid-svg-icons/faFilePowerpoint";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons/faFileCsv";
import { faFileArchive } from "@fortawesome/free-solid-svg-icons/faFileArchive";
import { faArrowUpWideShort } from "@fortawesome/free-solid-svg-icons/faArrowUpWideShort";
import { faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons/faArrowDownWideShort";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faWandSparkles } from "@fortawesome/free-solid-svg-icons/faWandSparkles";
import { faHdd } from "@fortawesome/free-solid-svg-icons/faHdd";
import { faCalendar } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faQrcode } from "@fortawesome/free-solid-svg-icons/faQrcode";
import { faCrown } from "@fortawesome/free-solid-svg-icons/faCrown";
import { faAd } from "@fortawesome/free-solid-svg-icons/faAd";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons/faLightbulb";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { faCode } from "@fortawesome/free-solid-svg-icons/faCode";
import { faChartLine } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { faGift } from "@fortawesome/free-solid-svg-icons/faGift";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { faUserShield } from "@fortawesome/free-solid-svg-icons/faUserShield";
import { faUserCog } from "@fortawesome/free-solid-svg-icons/faUserCog";
import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faMobile } from "@fortawesome/free-solid-svg-icons/faMobile";
import { faFolderPlus } from "@fortawesome/free-solid-svg-icons/faFolderPlus";
import { faFolder } from "@fortawesome/free-solid-svg-icons/faFolder";
import { faSun } from "@fortawesome/free-solid-svg-icons/faSun";
import { faMoon } from "@fortawesome/free-solid-svg-icons/faMoon";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";

// free brand
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faDiscourse } from "@fortawesome/free-brands-svg-icons/faDiscourse";
import { faLine } from "@fortawesome/free-brands-svg-icons/faLine";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";

library.add(
  faSun,
  faMoon,
  faCalendar,
  faHdd,
  faWandSparkles,
  faSpinner,
  faCheckCircle,
  faCopy,
  faQrcode,
  faCrown,
  faAd,
  faLightbulb,
  faGlobe,
  faCode,
  faChartLine,
  faGift,
  faStar,
  faDownload,
  faCloudUploadAlt,
  faUserShield,
  faUserCog,
  faTachometerAlt,
  faComments,
  faMobile,
  faLock,
  faUnlock,
  faList,
  faImage,
  faVideo,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCsv,
  faFileArchive,
  faArrowUpWideShort,
  faArrowDownWideShort,
  faStore,
  faUniversity,
  faCreditCard,
  faHeadset,
  faCoins,
  faCogs,
  faBolt,
  faSyncAlt,
  faCloudArrowDown,
  faEye,
  faEyeSlash,
  faChevronDown,
  faChevronUp,
  faClock,
  faShield,
  faLink,
  faRotateRight,
  faUpload,
  faFile,
  faEllipsisVertical,
  faMicrochip,
  faKey,
  faCalendarDays,
  faExclamationCircle,
  faSkullCrossbones,
  faPaperPlane,
  faCheck,
  faDiscourse,
  faUpLong,
  faCodeMerge,
  faUserGroup,
  faInfinity,
  faMinus,
  faPlus,
  faPlusCircle,
  faCloudArrowUp,
  faSignInAlt,
  faChevronRight,
  faShareNodes,
  faRocket,
  faShieldAlt,
  faUserAlt,
  faEnvelope,
  faHandHoldingUsd,
  faExclamation,
  faAngleDown,
  faAngleUp,
  faUsers,
  faLayerGroup,
  faTimesCircle,
  faTools,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faUserPlus,
  faRedoAlt,
  faSignOutAlt,
  faListUl,
  faHome,
  faTwitter,
  faExternalLinkAlt,
  faQuestionCircle,
  faTrash,
  faLine,
  faFacebook,
  faFolderPlus,
  faFolder,
);

const app = createApp(App);
const head = createHead();

app.mixin(adsUtils);
app.mixin(copyUtils);
app.mixin(toastUtils);
app.mixin(loadingUtils);
app.mixin(auth0Utils);
app.mixin(utilsUtils);
app.mixin(modalUtils);
app.mixin(downloadUtils);
app.mixin(emailUtils);
app.mixin(shareUtils);
app.mixin(groupUtils);
app.mixin(errorUtils);

app.component("font-awesome-icon", FontAwesomeIcon);
app.component("marquee-text", MarqueeText);

import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { setFaroInstance } from "./helpers/useFaro";
import { LogLevel } from "@grafana/faro-web-sdk";

// 最初にFaroを初期化し、グローバルに利用可能にする
const instrumentationOptions = {
  propagateTraceHeaderCorsUrls: [/localhost/, /api\.hstorage\.io/],
};

// 環境の判定ロジック：local, stg, prd の3つの環境に対応
const getEnvironment = () => {
  const mode = import.meta.env.MODE;
  if (mode === "production") {
    return "prd";
  } else if (mode === "staging") {
    return "stg";
  } else {
    return "local"; // development やその他のモードは local として扱う
  }
};

const faro = initializeFaro({
  url: import.meta.env.VITE_FARO_URL,
  apiKey: import.meta.env.VITE_FARO_API_KEY,
  instrumentations: [
    ...getWebInstrumentations({
      captureConsole: false,
    }),
    new TracingInstrumentation({ instrumentationOptions }),
  ],
  app: {
    name: "hstorage",
    version: "1.0.0",
    environment: getEnvironment(),
  },
});
// Faroインスタンスを設定
setFaroInstance(faro);

app.use(
  createAuth0({
    domain: "auth.hstorage.io",
    clientId: "gU0Zw3QFQFJlAY8kSiLRINc0yKiYvOpc",
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: "https://easyuploader.auth0.com/api/v2/",
    },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
  }),
);

app.use(Buefy, {
  defaultIconPack: "fas",
  defaultIconComponent: "font-awesome-icon",
});

app.use(VueMobileDetection);

app.use(VueLazyload, {
  error: "/static/images/loading.svg",
  loading: "/static/images/loading.svg",
});

import ScriptX from "vue-scriptx";

app.use(ScriptX);

import Ads from "vue-google-adsense";

app.use(Ads.Adsense);

app.use(i18n);

router.afterEach((to, from) => {
  const { name, fullPath } = to;
  faro.api.setView({ name: name });
  // Global canonical/hreflang injection (fallback for pages not specifying it)
  try {
    const origin = (import.meta?.env?.VITE_FRONT_URL || window.location.origin).replace(/\/$/, '')
    const seg1 = to.path.split('/')[1] || ''
    const base = to.path.replace(/^\/(ja|en)/, '') || '/'
    const jaPath = base === '/' ? '/ja' : `/ja${base}`
    const enPath = base === '/' ? '/en' : `/en${base}`
    const canonicalPath = seg1 === 'en' ? enPath : jaPath
    const canonical = `${origin}${canonicalPath}`
    const altJa = `${origin}${jaPath}`
    const altEn = `${origin}${enPath}`
    head.push({
      link: [
        { key: 'canonical', rel: 'canonical', href: canonical },
        { key: 'alt-ja', rel: 'alternate', hreflang: 'ja', href: altJa },
        { key: 'alt-en', rel: 'alternate', hreflang: 'en', href: altEn },
        { key: 'alt-x-default', rel: 'alternate', hreflang: 'x-default', href: altJa },
      ],
    })
  } catch (_) {}
});

app.config.errorHandler = (err) => {
  store.state.isError = true;
  store.state.errorMsg = err;
};

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});
client.interceptors.response.use(
  (response) => {
    return response;
  },
  // 2xxの範囲外にある任意のステータスコードはこの関数をトリガーします
  // レスポンスエラーで何かを実行する
  (error) => {
    if (error.response) {
      // 429 Too Many Requestsエラーを検出してモーダルを表示
      if (error.response.status === 429) {
        // ストアに直接アクセスしてモーダルを開く
        store.state.modal.rateLimited.open = true;
      } else if (error.response.status !== 400 && error.response.status !== 404) {
        faro.api.pushLog(["API Error"], {
          context: {
            payload: error.response,
          },
          level: LogLevel.ERROR,
        });
      }
    } else if (error.request) {
      // リクエストが行われましたが、レスポンスは受信されませんでした
      faro.api.pushError(error);
    } else {
      // リクエストの設定中にエラーがトリガーされた何かがありました
      faro.api.pushError(error);
    }
    return Promise.reject(error);
  },
);
axiosRetry(client, {
  retries: 5,
  retryDelay: function (retryCount, error) {
    return 1000;
  },
});
app.config.globalProperties.$axios = client;

app.use(TawkMessengerVue, {
  propertyId: "683b2f8f9796bf190d645cd3",
  widgetId: "1isjj3ilb",
});

app.use(router);
app.use(
  createRouterScroller({
    selectors: {
      window: true,
      body: true,
      ".scrollable": true,
    },
  }),
);
const store = createAppStore([]);
app.use(store);
app.use(head);
// Sync <html lang> with i18n locale globally
try {
  head.push({ htmlAttrs: { lang: i18n.global.locale } })
  if (i18n && i18n.global) {
    watch(
      () => i18n.global.locale,
      (val) => {
        head.push({ htmlAttrs: { lang: val } })
      }
    )
  }
} catch (_) {}
app.mount("#app");


// E2E（CI）支援: ネットワークに依存せず /uploaded へ遷移するユーティリティ
if (import.meta.env.VITE_E2E_MOCK === '1') {
  // 目視デバッグ用にフラグを公開
  window.__E2E_MOCK__ = '1'
  // /uploaded へ直接遷移（ストアにダミー結果を投入）
  window.__E2E_GO_UPLOADED__ = () => {
    try {
      const original = 'e2e-upload.txt'
      const size = 42
      store.state.uploadedFiles = [{
        id: 'e2e-mock-1',
        external_id: 'e2e-mock-external',
        original_file_name: original,
        file_type: 'text',
        size: size,
        url: 'https://example.invalid/dummy'
      }]
      router.push({ path: `/${i18n.global.locale}/uploaded`, query: { is_encrypt: false, password: '' } }).catch(() => {})
    } catch (_) {}
  }
}
